import { enableProdMode, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { CONFIG_DATA } from '@isa/core/config';
import { setDefaultOptions } from 'date-fns';
import { de } from 'date-fns/locale';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import * as moment from 'moment';
import 'moment/locale/de';

setDefaultOptions({ locale: de });
moment.locale('de');

registerLocaleData(localeDe, localeDeExtra);
registerLocaleData(localeDe, 'de', localeDeExtra);

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { canBootstrap } from './bootstrap-guard';

if (!isDevMode()) {
  enableProdMode();
}

async function bootstrap() {
  // main.ts imports the app modules only after canBootstrap allows the start.
  // A frame then runs no app module code.
  // The server sends no `Cache-Control` header for the config file.
  // With `no-cache` the browser asks the server for the file on each load.
  const [configRes, { App }, { appConfig }, { provideIsaServiceWorker }] =
    await Promise.all([
      fetch('/config/config.json', { cache: 'no-cache' }),
      import('./app/app'),
      import('./app/app.config'),
      import('./app/service-worker.providers'),
    ]);

  const config = await configRes.json();

  await bootstrapApplication(App, {
    ...appConfig,
    providers: [
      provideZoneChangeDetection(),{ provide: CONFIG_DATA, useValue: config },
      ...appConfig.providers,
      // The worker script depends on `diagnostics.enabled`, so the
      // registration needs the configuration read above.
      provideIsaServiceWorker(config),
    ],
  });
}

try {
  if (canBootstrap()) {
    bootstrap();
  }
} catch (error) {
  console.error(error);
}
